import axios from 'axios';
import { buildActingOrgHeader } from './actingOrg';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const actingHeader = buildActingOrgHeader();
    Object.entries(actingHeader).forEach(([k, v]) => { (config.headers as any)[k] = v; });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
// 只在「token 真的不再有效」时跳登录，避免业务 401/403 误触发跳转。
const TOKEN_INVALID_REASONS = ['TOKEN_EXPIRED', 'INVALID_TOKEN', 'UNAUTHENTICATED'];

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const reason = error.response?.data?.data?.reason;
    if (status === 401 && TOKEN_INVALID_REASONS.includes(reason)) {
      if (window.location.pathname !== '/login') {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
